import SimpleLightbox from "simplelightbox";

function initGallery() {
	var galleries = document.querySelectorAll('.lightgallery');

	if(galleries.length > 0){

		new SimpleLightbox('.lightgallery .lightbox-image', { 
			captions: false,
			animationSpeed: 200,
			overlayOpacity: 1,
			animationSlide: true,
			fadeSpeed: 200,
		});
	}
}

export default {
	initGallery,
}